module.exports = __webpack_public_path__ + "static/img/img_gsxx.4e23ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img_gsxx.png
// module id = BFzs
// module chunks = 1